import PropTypes from 'prop-types';
import { IconButton } from '@evertrue/et-components';

const ClearCustomFieldButton = ({ onClick = () => {} }) => (
  <IconButton
    icon="cancel"
    title="Clear Custom Field"
    className="interaction-custom-fields-form--cancel"
    tooltip="Clear"
    onClick={onClick}
  />
);

ClearCustomFieldButton.propTypes = {
  onClick: PropTypes.func,
};

export default ClearCustomFieldButton;
